import type WaDialog from '@awesome.me/webawesome/dist/components/dialog/dialog.js'
import type { Component } from 'solid-js'
import { Logger } from 'besonders-logger'
import { createSignal } from 'solid-js'
import { IconifyButton } from '../mini-components'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line unused-imports/no-unused-vars

const inputStyle = {
	'--wa-input-font-size-small': '11px',
}
export const TrustKeyDialog: Component<{
	actionFx: (seedString?: string) => void
}> = function TrustKeyDialog(props) {
	const [trustKeySeed, settrustKeySeed] = createSignal('')

	const onInput = (evt: InputEvent) => {
		settrustKeySeed((evt.target as HTMLInputElement).value)
	}

	const afterhide = async (hideargs) => {
		DEBUG({ hideargs })
	}

	let trustKeyDialogRef: WaDialog
	return (
		<>
			<IconifyButton
				{...{
					icon: 'gear',
					variant: 'success',
					text: 'Trust Key',
					title: 'Set up the "Trust Key" for your personal identity',
					onClick: () => (trustKeyDialogRef as any)?.show(),
					...props,
				}}
			/>
			<wa-dialog
				ref={trustKeyDialogRef}
				onwa-after-hide={afterhide}
				class='trustKeyDialog'
				w='90%'
			>
				<style>
					{`
					.trustKeyDialog::part(title) {
						padding: 0px;
					}
					.trustKeyDialog::part(panel) {
						width: 80%;
					}
					.trustKeyDialog::part(header) {
						padding: 1em 1em 0.5em 1em ;
					}
					.trustKeyDialog::part(body) {
						padding:  0.5em 1em 1em 1em;
					}
				`}
				</style>
				<h4 slot='label' py-1 px-2 m-0>
					Enter a name for the new trustKey:
				</h4>
				<wa-input
					placeholder='phoneXYZ'
					value={trustKeySeed()}
					onInput={onInput}
					filled
					font-mono
					size='s'
					max-w-full
					min-w-fit
					mb-4
					spellcheck={false}
					style={inputStyle}
				/>
				<IconifyButton {...{
					onClick: () => props.actionFx(trustKeySeed()),
					text: 'Save Trust Key',
					icon: 'floppy-disk',
					variant: 'primary',
				}}
				/>
				{/* <div>
					<wa-button
						max-w-fit
						variant={isKeyMatching() ? 'success' : 'default'}
						onClick={compareDerivedKeys}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify size={4} slot='start' name={isKeyMatching() ? 'check-circle' : 'question'} />
							Check
						</div>
					</wa-button>
					<wa-button
						max-w-fit
						ml-4
						variant='brand'
						onClick={async () => {
							settrustKey(createtrustKeyonic(24).join(',')) // in Memory signal only
							testStats(256, 10)
						}}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify size={4} slot='start' name='plus-circle' />
							New
						</div>
					</wa-button>
					<wa-button
						max-w-fit
						ml-4
						variant='brand'
						onClick={async () => {
							importDerivationKey(trustKeyArray())
							testStats(256, 10)
						}}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify slot='start' size='4' name='shield-plus' />
							Import
						</div>
					</wa-button>
					<wa-button
						max-w-fit
						ml-4
						variant='danger'
						onClick={dealWithStoredtrustKey}
						size='s'
					>
						<div flex='~ items-center' gap-1>
							<Iconify slot='start' size='4' name='shield-warning' />
							Export
						</div>
					</wa-button>
				</div> */}
			</wa-dialog>
		</>
	)
}
